import { render, staticRenderFns } from "./OnboardingWizard1Page.vue?vue&type=template&id=a86436e2&"
import script from "./OnboardingWizard1Page.vue?vue&type=script&lang=js&"
export * from "./OnboardingWizard1Page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports